import { NafCode } from '../NafCodeSelector';
import { showSuccessToast, showErrorToast } from '../../../utils/toastUtils';

// Utility hook for table operations
export const useTableUtils = (nafCodes: NafCode[]) => {
  const getNafCodeLabel = (code: string) => {
    const nafCode = nafCodes.find(naf => naf.code === code);
    return nafCode ? nafCode.intitule : code;
  };

  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text)
      .then(() => {
        showSuccessToast(
          'SIRET copié dans le presse-papier', 
          `siret-copied-${Date.now()}`,
          { position: 'bottom-right', autoClose: 2000 }
        );
      })
      .catch(() => {
        showErrorToast(
          'Impossible de copier le SIRET', 
          `siret-copy-error-${Date.now()}`,
          { position: 'bottom-right', autoClose: 2000 }
        );
      });
  };

  const openGoogleSearch = (name: string, city: string) => {
    const searchQuery = `${name} ${city || ''}`.trim();
    const encodedQuery = encodeURIComponent(searchQuery);
    window.open(
      `https://www.google.com/search?q=${encodedQuery}`,
      '_blank',
      'noopener,noreferrer'
    );
  };

  return { getNafCodeLabel, copyToClipboard, openGoogleSearch };
}; 